import React, {useEffect} from "react";
import Form from "../../lib/appfuse-react/component/Form";
import {Grid, Typography} from "@material-ui/core";
import SelectField from "../../lib/appfuse-react/component/SelectField";
import i18n from "../../lib/appfuse-react/core/i18n";
import {useDispatch, useSelector} from "../../store";
import {selectCounty, setCounty} from "../../reducer/util/utilReducer";
import lang from "../../lib/appfuse-react/core/lang";
import UserEvent from "../../lib/appfuse-react/core/UserEvent";
import TextField from "../../lib/appfuse-react/component/TextField";
import utilService from "../../service/util/utilService";

function Address(props){
    const {subtitle, value={}, variant, readOnly, required, withoutCountry, streetSize} = props;
    const county = useSelector(selectCounty);
    const {towns=[]} = county.find(item => item.code===value.county) || {};
    const keys = ['county', 'town', 'zip', 'street'];

    const streetXS = lang.isNotUndefined(streetSize)? streetSize:(withoutCountry? 4:6);

    const handleChange = ({value, change:{county, town}}) => {
        if(lang.isNotUndefined(county)) {
            value.town = null;
            value.zip = null;
        }
        if(lang.isNotUndefined(town)) {
            value.zip = towns.find(item => item.code===value.town)?.zip;
        }
        if(withoutCountry) {
            const notEmpty = keys.some(key => lang.isNotEmpty(value[key]));
            if(notEmpty) value.country = 'TW';
            else value.country = null;
        }
        props.onChange(new UserEvent({value}));
    };

    return (
        <Form value={value} onChange={handleChange} readOnly={readOnly}>
            {
                subtitle &&
                <Typography variant="subtitle1" gutterBottom color="textSecondary">
                    {i18n.translate(subtitle)}
                </Typography>
            }
            <Grid container spacing={2}>
                <Grid item xs={12-streetXS}>
                    <Grid container spacing={2}>
                        {
                            !withoutCountry && (
                                <Grid item xs={3}>
                                    {/*國家*/}<SelectField name="country" label='Country' variant={variant}
                                                         code='country' fullWidth required={required}/>
                                </Grid>
                            )
                        }
                        <Grid item xs={withoutCountry? 9:6}>
                            <Grid container spacing={2}>
                                {/*縣市*/}
                                <Grid item xs={6}>
                                    <SelectField name="county" label='City' variant={variant}
                                                 options={county} valueAccessor='code' textAccessor='name' fullWidth required={required}/>
                                </Grid>
                                {/*鄉鎮市(區)*/}
                                <Grid item xs={6}>
                                    <SelectField name="town" label='District' variant={variant}
                                                 options={towns} valueAccessor='code' textAccessor='name' fullWidth required={required}/>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/*郵遞區號*/}
                        <Grid item xs={3}>
                            <TextField name="zip" label='Zip' variant={variant}
                                       fullWidth required={required}/>
                        </Grid>
                    </Grid>
                </Grid>
                {/*街道*/}
                <Grid item xs={streetXS}>
                    <TextField name="street" label='Street' variant={variant} fullWidth required={required} />
                </Grid>
            </Grid>
        </Form>
    );
}

function MobileAddress(props) {
    const {subtitle, value={}, variant, readOnly, required, withoutCountry, streetSize} = props;
    const county = useSelector(selectCounty);
    const {towns=[]} = county.find(item => item.code===value.county) || {};
    const keys = ['county', 'town', 'zip', 'street'];

    const streetXS = lang.isNotUndefined(streetSize)? streetSize:(withoutCountry? 4:6);

    const handleChange = ({value, change:{county, town}}) => {
        if(lang.isNotUndefined(county)) {
            value.town = null;
            value.zip = null;
        }
        if(lang.isNotUndefined(town)) {
            value.zip = towns.find(item => item.code===value.town)?.zip;
        }
        if(withoutCountry) {
            const notEmpty = keys.some(key => lang.isNotEmpty(value[key]));
            if(notEmpty) value.country = 'TW';
            else value.country = null;
        }
        props.onChange(new UserEvent({value}));
    };

    return (
        <Form value={value} onChange={handleChange} readOnly={readOnly}>
            {
                subtitle &&
                <Typography variant="subtitle1" gutterBottom color="textSecondary">
                    {i18n.translate(subtitle)}
                </Typography>
            }
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        {
                            !withoutCountry && (
                                <Grid item xs={12}>
                                    {/*國家*/}<SelectField name="country" label='Country' variant={variant}
                                                           code='country' fullWidth required={required}/>
                                </Grid>
                            )
                        }
                        {/*縣市*/}
                        <Grid item xs={12}>
                            <SelectField name="county" label='City' variant={variant}
                                         options={county} valueAccessor='code' textAccessor='name' fullWidth required={required}/>
                        </Grid>
                        {/*鄉鎮市(區)*/}
                        <Grid item xs={12}>
                            <SelectField name="town" label='District' variant={variant}
                                         options={towns} valueAccessor='code' textAccessor='name' fullWidth required={required}/>
                        </Grid>
                        {/*郵遞區號*/}
                        <Grid item xs={12}>
                            <TextField name="zip" label='Zip' variant={variant}
                                       fullWidth required={required}/>
                        </Grid>
                    </Grid>
                </Grid>
                {/*街道*/}
                <Grid item xs={12}>
                    <TextField name="street" label='Street' variant={variant} fullWidth required={required} />
                </Grid>
            </Grid>
        </Form>
    );
}

const copy = (copyOne={}, beCopyOne={}) => {
    const keys = ['county', 'town', 'zip', 'street'];
    keys.forEach(key => { copyOne[key] = beCopyOne[key]; });
};
const compare = (compareOne={}, beCompareOne={}) => {
    const keys = ['county', 'town', 'zip', 'street'];
    let result = true;
    keys.forEach(key => { (compareOne[key] !== beCompareOne[key]) && (result = false) });
    return result;
};

Address.copy = copy;
Address.compare = compare;

export default Address;
export {MobileAddress};